import React, { FC } from 'react';
import ctaTypes from '../../../../enums/CTA.enums';
import CTA from '../../../@shared/cta';
import eventTypes from '../../../../enums/Event.enums';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import { TNavigationBarCtaDesktopProps } from '../types/navigationBar.types';
import useGetBuildAndPriceLink from '../../../../hooks/useGetBuildAndPriceLink';
import DictionaryTerm from '../../../@shared/dictionaryTerm';

const NavigationBarCtaDesktop: FC<TNavigationBarCtaDesktopProps> = (props) => {
  const { isEditorial, editorialCTA, button1, isMobile, clickPageNavEvent, enableBuildPriceCTA } = props;
  const buildAndPriceUrl = useGetBuildAndPriceLink('series');
  const hasButtons = !!(button1?.url && button1?.label) || (enableBuildPriceCTA && buildAndPriceUrl);
  if (isEditorial) {
    return (
      <>
        {!!(editorialCTA?.value?.href && editorialCTA?.value?.text) && (
          <div className={'navigation-bar__button-container'}>
            <CTA type={ctaTypes['p-red']} field={editorialCTA} />
          </div>
        )}
      </>
    );
  } else {
    return (
      <>
        {hasButtons && (
          <div className={'navigation-bar__button-container'}>
            {
              (enableBuildPriceCTA && buildAndPriceUrl) && (
                <RoutableNotEditableLink
                  href={appendRootToInternalLink(buildAndPriceUrl)}
                  className="navigation-bar__button"
                >
                  <DictionaryTerm keyword={'cnhi-build-price'} />
                </RoutableNotEditableLink>
              )
            }
            {
              !!(button1?.url && button1?.label) && (
                <RoutableNotEditableLink
                  href={appendRootToInternalLink(button1?.url)}
                  target={targetLinkdsk({ value: { href: button1?.url, target: button1?.target } }, !isMobile)}
                  className="navigation-bar__button"
                  onClick={() => clickPageNavEvent(eventTypes.ctaEvent, button1?.label)}
                >
                  {button1?.label}
                </RoutableNotEditableLink>
              )
            }
          </div>
        )}
      </>
    );
  }
};

export default NavigationBarCtaDesktop;
